<header class="atb">
  <div class="atb-left">
    <div class="atb-scope">
      <button type="button" class="atb-scope-btn" [class.atb-scope-btn--static]="!showGroups"
        [attr.aria-expanded]="menuOpen" (click)="toggleMenu()">
        <span class="atb-dot"></span>
        <span class="atb-scope-text">{{ scopeLabel }}</span>
        <span *ngIf="showGroups" class="material-icons atb-chevron">expand_more</span>
      </button>
      <div class="atb-menu" *ngIf="menuOpen" role="menu">
        <button type="button" class="atb-menu-item" role="menuitem" [class.atb-menu-item--active]="isActive(null)" (click)="pick(null)">
          {{ networkName }}
          <small>See the entire connected fan network</small>
        </button>
        <button type="button" *ngFor="let group of groups" class="atb-menu-item" role="menuitem"
          [class.atb-menu-item--active]="isActive(group)" (click)="pick(group)">
          {{ groupName(group) }}
        </button>
      </div>
    </div>
  </div>
  <div class="atb-right">
    <span class="atb-made"><span class="atb-made-dot"></span><span class="atb-made-text">Made for you</span></span>
    <button type="button" class="atb-icon-btn atb-hub-toggle" (click)="toggleHub.emit()" [matTooltip]="isHubOpen ? 'Collapse panel' : 'Expand panel'"
      [attr.aria-label]="isHubOpen ? 'Collapse panel' : 'Expand panel'">
      <span class="material-icons">{{ isHubOpen ? 'keyboard_double_arrow_right' : 'menu' }}</span>
    </button>
    <button type="button" class="atb-icon-btn" (click)="minimize.emit()" matTooltip="Minimize">
      <span class="material-icons">remove</span>
    </button>
  </div>
</header>
